import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {ProductRecommendationsPageService_GetRecommendationsPageLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/product_recommendations_page/v1/service.grpc.lazy';
import {useHydrationDone} from '@aboutyou/lazy-imports';
import {useOptionalSession} from '@aboutyou/user';
import {useEffect, useState} from 'react';
import {useProductIdFromSlug} from '../../../features/ProductUrl';
import {useReductionsStateRequestParameter} from '../../../features/ReductionsState/useReductionsStateRequestParameter';
import {useTargetGroupIdentifier} from '../../../shared-deprecated/useTargetGroupIdentifier';

export const useSimilarProducts = (
  {disabled}: {disabled?: boolean} = {disabled: false},
) => {
  const session = useOptionalSession();
  const targetGroup = useTargetGroupIdentifier();
  const productId = useProductIdFromSlug();

  return useGrpcRequest(
    ProductRecommendationsPageService_GetRecommendationsPageLazy,
    {
      productId: productId!,
      session,
      reductionsState: useReductionsStateRequestParameter(),
      targetGroup,
      recommendationType: {
        type: {
          $case: 'similar',
          similar: {},
        },
      },
    },
    {
      disabled,
    },
  );
};

export const useSimilarProductsClientOnly = () => {
  const [disabled, setDisabled] = useState(true);

  const request = useSimilarProducts({disabled});
  const isHydrationDone = useHydrationDone();

  useEffect(() => {
    if (isHydrationDone) {
      // eslint-disable-next-line local-rules/set-state-in-use-effect
      setDisabled(false);
    }
  }, [isHydrationDone]);

  return request;
};

export const useHasSimilarProductsRecommendations = () => {
  const request = useSimilarProductsClientOnly();

  return Boolean(request.data?.recommendations.length);
};
